import {RoomCBT} from '@/core/api/room.cbt.api';
import {RoomDoc} from "@/core/api/room.doc.api";

export default {
	/**
	 * CBT 목록 조회
	 */
	async getCBTList({ commit }, params) {
		const data = await RoomCBT.getCBTList(params);
		commit('SET_CBT_LIST', data);
		return data
	},

	/**
	 * CBT 문제지 업로드
	 */
	async uploadCBTDoc({}, params) {
		return await RoomCBT.uploadCBTDoc(params);
	},

	/**
	 * CBT 조회
	 */
	async getCBT({ commit }, params) {
		const { data: roomCBT } = await RoomCBT.getCBT(params);
		commit('SET_SELECTED_CBT', roomCBT);
		return roomCBT;
	},

	/**
	 * CBT 생성
	 */
	async createCBT({ dispatch }, params) {
		const { data: roomCBTDoc } = await dispatch('uploadCBTDoc', {
			multipartFile: params.multipartFile,
			filename: params.filename,
			roomId: params.roomId,
			groupId: params.groupId
		})

		return await RoomCBT.createCBT({
			cbtTitle: params.cbtTitle,
			groupId: params.groupId,
			roomId: params.roomId,
			docId: roomCBTDoc.docId,
			questionList: params.questionList
		});
	},

	/**
	 * CBT 삭제
	 */
	async deleteCBT({}, params) {
		return await RoomCBT.deleteCBT(params);
	},

	/**
	 * CBT 시작
	 */
	async startRoomCBT({ dispatch, rootGetters }, params) {
		const roomDoc = rootGetters['doc/getRoomDocFile']({
			docId: params.docId,
			roomGroupId: 'default'
		});

		if (!roomDoc) {
			throw new Error('아직 문제지가 업로드되지 않았습니다.');
		}

		const roomDocFirstPage = roomDoc.pages[0]

		dispatch('room/changeRoomMode', { roomMode: 'CBT' }, { root: true });
		dispatch('doc/changeRoomDocPage', {
			docId: roomDocFirstPage.docId,
			docPageId: roomDocFirstPage.docPageId,
			docPageSeq: roomDocFirstPage.docPageSeq,
			roomGroupId: 'default'
		}, { root: true });
		return await RoomCBT.startRoomCBT(params);
	},

	/**
	 * CBT 종료
	 */
	async endRoomCBT({ dispatch }, params) {
		dispatch('room/changeRoomMode', { roomMode: 'call' }, { root: true });
		return await RoomCBT.endRoomCBT(params);
	},

	/**
	 * CBT 제출
	 */
	async completeRoomCBTUser({}, params) {
		return await RoomCBT.completeRoomCBTUser(params);
	},

	/**
	 * CBT 답안 제출
	 */
	async submitRoomCBTUserAnswerList({}, params) {
		return await RoomCBT.submitRoomCBTUserAnswerList(params);
	},

	/**
	 * CBT Doc 조회
	 */
	async getRoomCBTUserDoc({}, params) {
		return await RoomCBT.getRoomCBTUserDoc(params);
	},

	/**
	 * CBT Doc Page 변경
	 */
	async changeRoomCBTUserDocPage({ commit }, params) {
		const { downloadUrl, roomCbtUserDoc } = await RoomCBT.changeRoomCBTUserDocPage(params);

		await RoomDoc.getRoomDocUrl({
			roomGroupId: 'default',
			docId: roomCbtUserDoc.docId,
			docPageId: roomCbtUserDoc.docPageId,
			downloadUrl: downloadUrl
		}).catch(e => {
			console.error(e);
		});

		commit('doc/changeRoomDocFilePage', {
			roomGroupId: 'default',
			...roomCbtUserDoc
		}, {root: true})
	},

	/**
	 * CBT 출제 이력 목록 조회
	 */
	async getCBTLogList({ commit }, params) {
		const data = await RoomCBT.getCBTLogList(params);
		commit('SET_CBT_LOG_LIST', data);
		return data;
	},

	/**
	 * CBT 출제 이력 상세 조회
	 */
	async getCBTLog({ commit }, params) {
		const { data } = await RoomCBT.getCBTLog(params);
		commit('SET_CBT_LOG', data);
		return data;
	}
}
